<template>
  <div class="sl-image-uploader">
    <input ref="input" type="file" class="d-none" @change="setFile" />
    <template v-if="localSrc">
      <div class="sl-image-uploader__preview">
        <img :src="localSrc" alt="logo preview" />
      </div>
      <ui-button
        class="change-btn"
        icon="icon-edit"
        icon-size="22"
        shadow
        @click="selectFile"
      ></ui-button>
    </template>

    <div v-else class="sl-image-uploader__add" @click="selectFile">
      <v-icon color="primary">mdi-plus</v-icon>
      {{ $t("message.storeLocator.basic.addLogo") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorConfigImageUploader",
  props: {
    src: {
      type: String
    }
  },
  data: () => ({
    file: null,
    imgSrc: null
  }),
  computed: {
    localSrc() {
      return this.imgSrc || this.src;
    }
  },
  methods: {
    setFile(event) {
      this.file = event.target.files.length ? event.target.files[0] : null;
      if (!this.file) {
        this.imgSrc = null;
        this.onChange(this.file);
      }

      if (!this.file.type.includes("image/")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.onChange(this.file);
        };
        reader.readAsDataURL(this.file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    selectFile() {
      this.$refs.input.click();
    },
    onChange(file) {
      this.$emit("change", file);
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-image-uploader {
  width: 124px;
  height: 124px;
  background: $light-4;
  margin: 0 $spacing * 9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  position: relative;

  &__add {
    @include font-size(14px);
    line-height: 17px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding: $spacing * 1.25;
    color: $primary;
  }

  &__preview {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    border: 1px solid $light-3;
    background: $light;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }
  }

  .change-btn {
    position: absolute;
    bottom: 0;
    right: -24px;
  }
}
</style>
